import { render, staticRenderFns } from "./SiteWorkflow.vue?vue&type=template&id=c4a51004"
import script from "./SiteWorkflow.vue?vue&type=script&lang=js"
export * from "./SiteWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports